import * as React from 'react';

import { DragPreviewCard } from './DragPreviewCard';
import type { DNDItem } from './types';

/** Renders the standard preview inside dnd-kit's DragOverlay. */
export function DragOverlayPreview(props: {
    item: DNDItem;
    /**
     * Visually hide the card while keeping it mounted so dnd-kit can measure the overlay.
     * Used while the earlier page-drag preview provides the visible card instead.
     */
    hidden?: boolean;
}): React.ReactElement {
    const { item, hidden } = props;

    return (
        <DragPreviewCard
            icon={item.previewIcon}
            label={item.previewLabel || 'Drop to insert'}
            className="absolute top-1/2 left-[calc(50%+12px)] -translate-y-1/2"
            style={hidden ? { visibility: 'hidden' } : undefined}
        />
    );
}
